<template>

    <div class="node" v-show="visible && showVal && nodeInfo.propsLoading !== true" :class="{active:isActive}" :style="computedStyle" @click.stop="handleClick">
        <template v-if="currPage==='root' || !nodeInfo.lazyLoad">
            <component @show='showNode' :is="currPage" :data-node-id="nodeInfo.id" :data-node-type="nodeInfo.type" :data-node-version="nodeInfo.version" v-bind="filterProps" :ref="nodeInfo.id">
                <template v-if="nodeInfo.child && !!slots">
                    <node v-for="(item, index) in nodeInfo.child" :slot-style='slots(index) && slots(index).style' :slot="slots(index) && slots(index).name" :key="item.id" :stacked='nodeInfo.stack' :scope="scope" :info="item"></node>
                </template>
            </component>
            <template v-if="hasChild && !slots">
                <node v-for="item in nodeInfo.child" :key="item.id" :stacked='nodeInfo.stack' :scope="scope" :info="item"></node>
            </template>
        </template>

        <template v-else>
            <lazy-component :threshold="$root.lazyMargin">
                <template v-slot:default>
                    <component @show='showNode' @hook:mounted="doAfterMounted" :is="currPage" :data-node-id="nodeInfo.id" :data-node-type="nodeInfo.type" :data-node-version="nodeInfo.version" v-bind="filterProps" :ref="nodeInfo.id">
                        <template v-if="nodeInfo.child && !!slots">
                            <node v-for="(item, index) in nodeInfo.child" :slot-style='slots(index) && slots(index).style' :slot="slots(index) && slots(index).name" :key="item.id" :stacked='nodeInfo.stack' :scope="scope" :info="item"></node>
                        </template>
                    </component>
                    <template v-if="hasChild && !slots">
                        <node v-for="item in nodeInfo.child" :key="item.id" :stacked='nodeInfo.stack' :scope="scope" :info="item"></node>
                    </template>
                </template>
                <template v-slot:skeleton>
                    <img :src="nodeInfo.skeleton">
                </template>
            </lazy-component>
        </template>
    </div>
</template>
<style lang="stylus" rel="stylesheet/stylus" scoped type="text/stylus">
.node {
    position: relative;
    font-size: 16px;

    &::before {
        content: '';
        display: block;
        overflow: hidden;
        height: 0;
        width: 1px;
    }
}
</style>
<style>
.node div[data-node-id]:first-child {
    background-color: inherit;
    border-radius: inherit;
    color: inherit;
}
</style>
<script type="text/ecmascript-6">
import cLoader from '@/extend/componentLoader'
import BaseNode from '@/extend/BaseNode'
import cloneDeep from 'lodash/cloneDeep'
import WebComponent from '@/extend/WebComponent'
import { needTranslate } from '@/extend/Util.js'

export default {
    mixins: [BaseNode, WebComponent],
    name: 'node',
    props: {
        scope: {
            type: Object,
        },
        stacked: {
            type: Boolean,
            default: true,
        },
        info: {
            required: true,
            type: Object,
        },
        slotStyle: {
            type: Object,
            default: null,
        },
    },
    data: function () {
        return {
            showVal: true,
            oldId: '',
            isActive: false,
            currPage: '',
            oldStyle: {},
            nodeInfo: (() => {
                if (this.scope) {
                    return cloneDeep(this.info)
                } else {
                    return this.info
                }
            })(),
            slots: this.info.hasSlot ? (i) => `slot${i}` : false,
            loadBeginTime: new Date().getTime(),
        }
    },
    watch: {
        'nodeInfo.visible': function (val, old) {
            if (old === false && val) {
                this.doAfterMounted()
            }
        },
        info: {
            deep: true,
            handler: function (newVal) {
                var info = {}
                if (this.scope) {
                    info = cloneDeep(newVal)
                } else {
                    info = newVal
                }
                this.nodeInfo = info
            },
        },
        scope: {
            handler: function (val) {
                if (!val) return
                this.$nextTick(this.passScopeToComponentInstance)
            },
            deep: true,
        },
    },
    computed: {
        visible: {
            // getter
            get: function () {
                if (this.nodeInfo) {
                    return this.nodeInfo.visible
                } else {
                    return false
                }
            },
            // setter
            set: function (newValue) {
                this.nodeInfo.visible = newValue
            },
        },
        nodeChild() {
            return this.nodeInfo.child || []
        },
        hasChild() {
            return this.nodeChild && this.nodeChild.length > 0
        },
        filterProps() {
            const props = {}
            Object.keys(this.nodeInfo.props).forEach(key => {
                if (key.startsWith('$')) return
                props[key] = this.nodeInfo.props[key]
            })
            return props
        }
    },
    beforeDestroy: function () {
        delete window.$_nodePrecomponents[this.oldId]
    },
    created() {
        this.translateProps()
    },
    async mounted() {
        this.oldId = this.nodeInfo.id
        if (this.nodeInfo.policyAttrSwitch === true) {
            this.propsLoading = true
            const { props, expression } = await this.getPropsFromApi()
            this.nodeInfo.props = props
            this.nodeInfo.calcSuccessExpression = expression

            console.log(
                this.nodeInfo.id,
                'policyAttr',
                'calcSuccessExpression',
                this.nodeInfo.calcSuccessExpression
            )
            if (
                this.nodeInfo.calcSuccessExpression &&
                this.nodeInfo.calcSuccessExpression.length > 0
            ) {
                this.propsLoading = false
            }
        }
        this.registerNodeToGlobal()
        this.doLoad()
    },
    methods: {
        cloneDeep: cloneDeep,
        // 根据接口获取props
        async getPropsFromApi() {
            const userData = await Promise.all([
                window.AllBridge.getUserInfo(),
                window.AllBridge.getClientInfo(),
            ])

            const onlyUserData =
                userData && userData.length > 0 ? userData[0] : null
            const onlyClientData =
                userData && userData.length > 1 ? userData[1] : null

            return new Promise((resolve, reject) => {
                window.AllBridge.request({
                    $nodeId: this.nodeInfo.id,
                    $nodeLabel: this.nodeInfo.label,
                    $nodeType: this.nodeInfo.type,
                    $nodeVersion: this.nodeInfo.version,
                    url: this.api.getNodeConfig,
                    method: 'post',
                    headers: {
                        'All-Embracing-Get-Html-AppUk':
                            'marketcenter.java.active.template.website',
                        'All-Embracing-Get-Html-Token':
                            '589abf2c-fbb5-4c1b-98e3-40e808055ce7',
                        'AllE-Activity-Id':
                            'alle_' + this.$route.params.pageKey,
                    },
                    data: {
                        activityId: 'alle_' + this.$route.params.pageKey,
                        historyId: this.$route.query.historyId,
                        draft: this.$route.path.indexOf('/draft/') >= 0,
                        nodeId: this.nodeInfo.id,
                        nodeType: this.nodeInfo.type,
                        nodeVersion: this.nodeInfo.version,
                        logicEnv: this.$route.query.logicEnv,
                        clearCache: false,

                        memberId: onlyUserData.tcMemberId,
                        realPhone: onlyUserData.mobile,
                        deviceId: onlyClientData.deviceId,
                        tcAppToken: onlyClientData.deviceToken,
                    },
                })
                    .then((res) => {
                        if (res && res.data && res.data.code === '0000') {
                            resolve(res.data.result)
                        }
                    })
                    .catch((error) => reject(error))
            })
        },
        /**
         * 获取组件对象
         * @param {String} id  组件id
         * @param {boolean} child 是否获取组件内部元素
         */
        getComponent(id, child) {
            var component = window.$_nodePrecomponents[id]
            if (child && component) {
                return component.$refs[id]
            }
            return component
        },
        registerNodeToGlobal() {
            window.$_nodePrecomponents = window.$_nodePrecomponents || {}
            window.$_nodePrecomponents[this.nodeInfo.id] = this
            window.$event = window.$event || []
            window.$event.push(this.nodeInfo.events)
        },
        passScopeToComponentInstance() {
            let scope = this.scope
            let $childInstance = this.$refs[this.nodeInfo.id]
            scope &&
                $childInstance &&
                $childInstance.$set(
                    $childInstance.$data,
                    'inscope',
                    scope.data || scope
                )
        },
        async doLoad() {
            if (this.nodeInfo.type === 'node') return
            const component = await cLoader.load(this.nodeInfo)
            if (!component) return
            this.slots = this.calcSlots(component, this.nodeInfo.props)
            this.currPage = this.nodeInfo.id
            if (this.nodeInfo.webComponent) {
                await this.$nextTick()
                this.registerWebComponent()
            } else if (!this.isNodeRegisted(this.nodeInfo.id)) {
                this.registerNode(this.nodeInfo)
            }
            if (this.nodeInfo.lazyLoad) return
            this.doAfterMounted()
        },
        doAfterMounted() {
            this.$nextTick(() => {
                window.app.$emit(
                    '$doLoadNode-' + this.nodeInfo.id,
                    this.$refs[this.nodeInfo.id]
                )
                this.passScopeToComponentInstance()
                this.runAnimate()
            })
        },
        isNodeRegisted(tag) {
            return Boolean(Vue.component(tag))
        },
        isNodeStartRegister(tag) {
            return tag in (window.$_nodePrecomponents || {})
        },
        handleClick(event) {
            let componentInstance
            if (this.nodeInfo.webComponent) {
                componentInstance = document.querySelector("[data-node-id='" + this.nodeInfo.id + "']")
            } else {
                componentInstance = this.$refs[this.nodeInfo.id]
            }
            const allBridge = componentInstance && componentInstance.allBridge
            window.app.$emit('$node_click', {
                nodeInfo: this.nodeInfo,
                allBridge,
            })

            allBridge &&
                allBridge
                    .allCompCommonEventTrack({
                        action: 'node_click',
                        value: {},
                    })
                    .then((res) => {})
        },
        showNode(showVal) {
            this.showVal = showVal
        },
        /**
         * 递归翻译对象中的字符串值
         * @param {any} obj - 需要翻译的对象/数组/字符串
         * @returns {any} - 翻译后的对象
         */
        translateRecursively(obj) {
            if (!obj) return obj
            if (typeof obj === 'string') {
                return window.AllBridge.t(obj)
            }
            // 如果是数组，递归处理每个元素
            if (Array.isArray(obj)) {
                return obj.map(item => this.translateRecursively(item))
            }
            // 如果是对象，递归处理每个属性
            if (typeof obj === 'object') {
                const result = {}
                Object.keys(obj).forEach(key => {
                    result[key] = this.translateRecursively(obj[key])
                })
                return result
            }
            return obj
        },
        translateProps() {
            if (!needTranslate()) return
            if (!this.nodeInfo.propTranslate) return
            const propTranslate = this.nodeInfo.propTranslate
            const props = this.nodeInfo.props
            Object.keys(propTranslate).forEach((key) => {
                if (propTranslate[key]) {
                    props[key] = this.translateRecursively(props[key])
                }
            })
        }
    },
}
</script>

